import "./App.css";
import img1 from "./imgs/avatar1.webp";
import img2 from "./imgs/avatar2.webp";
import img3 from "./imgs/avatar3.webp";
import img4 from "./imgs/avatar4.webp";

function CustomersSay() {
  const styles = {
    testimonials: {
     display: "flex",
     flexDirection: "column",
    },
    h1: {
     textAlign: "center",
     marginTop: 15,
    },
    masterRating: {
     display: "flex",
     flexDirection: "row",
     justifyContent: "space-between",
     margin: 50,
    },
    avatar: {
     display: "flex",
     alignItems: "center",
    },
    avatarImg: {
     width: 90,
    },
    avatarH5: {
     marginLeft: 5,
    },
    rating: {
     marginBottom: 10,
    },
    userRating: {
     border: "1px solid black",
     borderRadius: 5,
     padding: 15,
     boxShadow: "5px 10px #888888",
    },
    userRatingP: {
     fontFamily: "Karla",
     fontSize: 18,
     width: 190,
    },
    checked: {
     color: "orange",
    },
   };

 const customer = [{
  id: 0, // Used in JSX as a key

  //  wrong
  // avatar: './imgs/outro.webp';
  //  wrong
  // avatar: `url(${process.env.PUBLIC_URL}/avatar1.webp)`,
  // also wrong
  // avatar: {img1},

  // corrected, imported img1 first.
  avatar: img1,

  name: 'Cheong Min',
  say: 'I recently dined at The Little Lemon, and it was a splendid experience with incredibly flavorful food and favorable service. Highly recommended.',
}, {
 id: 1, 
 avatar: img2,
  name: 'HARDWELL',
  say: 'It was an excellent experience with perfectly cooked food, a pleasant atmosphere, and friendly, attentive staff. Highly recommended.',
},{
 id: 2, 
 avatar: img3,
 name: 'Leona J.',
 say: 'Very truly impressed. Delicious food, top-notch service, and incredibly friendly staff. Highly recommended.',
},{
 id: 3, 
 avatar: img4,
 name: 'Nur Samila',
 say: 'Alhamdulillah, this restaurant at least has a HALAL in town known for its delicious foods, though some may find it expensive.',
}];


const customers = customer.map(customer => 

<div style={styles.userRating} key={customer.id}>
      <div style={styles.rating}>
      ⭐⭐⭐⭐⭐
      </div>
      <div style={styles.avatar}>
       <img src={customer.avatar} alt="user-face-rounded" style={styles.avatarImg} />
       <h5 style={styles.avatarH5}>{customer.name}</h5>
      </div>
      <p style={styles.userRatingP}>
      {customer.say}
      </p>
     </div>




);


return  <article style={styles.testimonials}>
        <h1 style={styles.h1}>Testimonials</h1>
          <div style={styles.masterRating}>{customers}</div>
        </article>;
}

export default CustomersSay;
